import { gql } from "@apollo/client";

export const REPORT = gql`
  mutation report($id: Int!, $content: String, $reason: ReportReasons!) {
    Report {
      create(id: $id, content: $content, reason: $reason)
    }
  }
`;

export const REPORT_IMAGES_ISSUE = gql`
  mutation reportImagesIssue($listing_id: Int!, $images: [String]) {
    Listing {
      reportImagesIssue(listing_id: $listing_id, images: $images)
    }
  }
`;

export const REPORT_NOT_FOUND_PAGE = gql`
  mutation reportNotFoundPage(
    $path: String!
    $referral: String
    $code: String
    $rawError: String
  ) {
    Web {
      reportNotFoundPage(
        path: $path
        referral: $referral
        code: $code
        raw_error: $rawError
      )
    }
  }
`;

export const REGISTER_GENERAL_EVENT = gql`
  mutation RegisterGeneralEvent($action: String!) {
    Report {
      registerGeneralEvent(action: $action)
    }
  }
`;
